import {
  IAutoQuestionAutomationFormData,
  autoQuestionAutomationDefaults,
} from '@employer/app/components/jobs-automation/automation-auto-question/auto-questions.model'

import { IApplicationAutoResponseFormData, autoResponseDefaults } from './auto-response.model'
import { IRejectCandidateFormData, rejectCandidateDefaults } from './automation-candidate-rejection/candidate-rejection.model'
import { IRequestMoreFormData, requestMoreFormDefaults } from './automation-request-updates/auto-request-updates.model'
import { IUnresponsiveCandidateFormData, unresponsiveCandidateDefaults } from './automation-unresponsive-candidate/unresponsive-candidate.model'
import { ICultureIndexFormData, cultureIndexDefaults } from './culture-index.model'

export interface IAutomationFormData {
  autoResponse: IApplicationAutoResponseFormData
  cultureIndex?: ICultureIndexFormData
  requestMore: IRequestMoreFormData
  autoQuestions: IAutoQuestionAutomationFormData
  unresponsiveCandidate?: IUnresponsiveCandidateFormData
  rejectCandidate?: IRejectCandidateFormData
}

export interface IAutomationDefaultMessages {
  autoResponseMessage: string
  autoQuestionMessage: string
  autoQuestionFollowUpMessage: string
  autoQuestionWarningMessage: string
  requestUpdatesMessage: string
  requestUpdatesFollowUpMessage: string
  requestUpdatesWarningMessage: string
  cultureIndexMessage: string
  cultureIndexFollowUpMessage: string
  cultureIndexWarningMessage: string
}

export const automationFormDefaults: IAutomationFormData = {
  autoResponse: autoResponseDefaults,
  cultureIndex: cultureIndexDefaults,
  requestMore: requestMoreFormDefaults,
  autoQuestions: autoQuestionAutomationDefaults,
  unresponsiveCandidate: unresponsiveCandidateDefaults,
  rejectCandidate: rejectCandidateDefaults,
}
